/**
 * 呼び出し元画面への出力情報を格納するVO
 *
 * @export KYMW0800OutputModel
 * @class KYMW0800OutputModel
 */
export class KYMW0800OutputModel {
}
